import { isEmpty } from 'lodash';
import { Region } from '../region/region';

/**
 * Exceptions DTO
 */
export class ExceptionsDTO {
  /**
   * @constructor
   */
  constructor(
    public regionId: number,
    public name: string,
    public countries: Region[],
    public allCountries: boolean
  ) {}

  /**
   * extracts the countries from an exception array
   * @param {Exceptions[]} exceptions
   * @return {number[]} ids of the exempted countries
   */
  static selectedCountryIds(exceptions: ExceptionsDTO[]): number[] {
    if (!isEmpty(exceptions)) {
      return exceptions.flatMap((r) => r.countries.map((c) => c.id));
    }
    return [];
  }
}
